import appApi from '../../../../../../../api/app-api';
import { AbstractCourse } from '../../../../../../../api/types/settings/studies/abstract-course';
import { toast } from 'react-toastify';
import globalSettingsStores from '../../../../../../../stores/settings-stores';

export const abstractProgramAddCourses = async (
  abstractProgramId: number,
  abstractCourses: AbstractCourse[] | null,
  closeDialog: () => void,
) => {
  // TODO
  console.log('abstractProgramAddCourses');

  try {
    if (!abstractCourses || abstractCourses.length === 0) {
      toast.warn('יש לבחור קורסים להוספה');
      return;
    }

    const abstractCoursesIds = abstractCourses.map((item) => item.id);

    await appApi.addAbstractProgramCourses(
      abstractProgramId,
      abstractCoursesIds,
    );

    // Update the state
    globalSettingsStores.abstractProgram =
      globalSettingsStores.abstractProgram.map((program) =>
        program.id === abstractProgramId
          ? {
              ...program,
              courses: [...program.courses, ...abstractCourses],
            }
          : program,
      );
    toast.success('הפעולה בוצעה בהצלחה');
    closeDialog();
  } catch (e) {
    console.error(
      `abstractProgramAddCourses is failed with the abstractProgramId: ${abstractProgramId}, abstractCourses: ${abstractCourses} adn the error: ${e}`,
    );
    toast.error('הוספת הקורסים נכשלה, יש לנסות שוב בעוד מספר רגעים');
  }
};
